import React, { useEffect, useState } from 'react';
import { parseISO, differenceInSeconds } from 'date-fns';
import { useLocation } from 'react-router-dom';
import AjustesMenu from './AjustesMenu';
import UserMenu from './UserMenu';

function RelojCuentaAtras({ fechaExp }) {
  const calcularTiempo = (fechaDestino) => {
    const ahora = new Date();
    const totalSegundos = Math.max(0, differenceInSeconds(fechaDestino, ahora));
    const dias = Math.floor(totalSegundos / (3600 * 24));
    const horas = Math.floor((totalSegundos % (3600 * 24)) / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60;
    return { dias, horas, minutos, segundos };
  };
  
  const fecha = typeof fechaExp === 'string' ? new Date(fechaExp) : fechaExp;
  const [tiempoRestante, setTiempoRestante] = useState(() => calcularTiempo(fecha));
  
  const [color, setColor] = useState(() => {
    const ahora = new Date();
    const totalSegundos = Math.max(0, differenceInSeconds(fecha, ahora));
    const dias = Math.floor(totalSegundos / (3600 * 24));
    if (totalSegundos <= 0 || dias < 1) return 'red';
    if (dias < 10) return 'yellow';
    return 'white';
  });
  
  const location = useLocation();

  const rutasConReloj = ['/dashboard'];
  const mostrarReloj = rutasConReloj.includes(location.pathname);

  useEffect(() => {
    const intervalo = setInterval(() => {
      const ahora = new Date();
      const destino = typeof fechaExp === 'string' ? new Date(fechaExp) : fechaExp;
      const totalSegundos = Math.max(0, differenceInSeconds(destino, ahora));

      const dias = Math.floor(totalSegundos / (3600 * 24));
      const horas = Math.floor((totalSegundos % (3600 * 24)) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      setTiempoRestante({ dias, horas, minutos, segundos });

      if (totalSegundos <= 0) setColor('red');
      else if (dias < 1) setColor('red');
      else if (dias < 10) setColor('yellow');
      else setColor('white');
    }, 1000);

    return () => clearInterval(intervalo);
  }, [fechaExp]);

  const pad = n => String(n).padStart(2, '0');
  const { dias = 0, horas = 0, minutos = 0, segundos = 0 } = tiempoRestante;
  const texto =
    dias === 0 && horas === 0 && minutos === 0 && segundos === 0
      ? 'Cuenta expirada'
      : `${dias}d ${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;

  return (
    <>
      {/* AjustesMenu en esquina superior derecha */}
      <div style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        zIndex: 2001
      }}>
        <AjustesMenu />
      </div>

      {/* UserMenu en esquina superior izquierda */}
      <div style={{
        position: 'fixed',
        top: '10px',
        left: '10px',
        zIndex: 2000
      }}>
        <UserMenu />
      </div>

      {/* Contenedor del reloj centrado */}
      {mostrarReloj && (
        <div style={styles.wrapper}>
          <div style={{ ...styles.reloj, color }}>{texto}</div>
        </div>
      )}
    </>
  );
}

const styles = {
  wrapper: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: '#000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    flexDirection: 'column',
    textAlign: 'center',
    padding: '1rem'
  },
  reloj: {
    fontSize: 'min(12vw, 8rem)',
    fontWeight: 'bold',
    lineHeight: 1.2,
    wordBreak: 'break-word'
  }
};

export default RelojCuentaAtras;
